const Continue = () =>
  import('@/views/main/live/statisticalContinue/StatisticalContinue.vue')
export default {
  path: '/main/live/continue',
  name: 'Continue',
  component: Continue,
  children: []
}
